export function getInitUrl() {
  return import.meta.env.VITE_INIT ?? "";
}

export function getBffUrl() {
  return import.meta.env.VITE_BFF ?? "";
}

export function getBffIndUrl() {
  return import.meta.env.VITE_BFF_IND ?? "";
}

export function getEnvironment() {
  return import.meta.env.VITE_ENVIRONMENT ?? "";
}

export const TOKEN_TTL_MINUTES = 24;

export const SESSION_KEYS = {
  MAIN_AWS_AUTH_TOKEN: "token",
  MAIN_MASTER_INIT_TOKEN: "mToken",
  MAIN_SLAVE_INIT_TOKEN: "sToken",
  IND_AWS_AUTH_TOKEN: "tokenIND",
  IND_INIT_TOKEN: "sTokenIND",
} as const;

export function getMainInitTokenStorageKey() {
  return getEnvironment() === "master"
    ? SESSION_KEYS.MAIN_MASTER_INIT_TOKEN
    : SESSION_KEYS.MAIN_SLAVE_INIT_TOKEN;
}